import {
  CButton,
  CCardHeader,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";

import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { formatDate } from "src/shared/Format/dateFormat";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
const TransferLotRequestHOListView = () => {
  let history = useHistory();

  let { lotTransferId } = useParams();
  const [viewListDetails, setviewListDetails] = useState();
  const [viewTenderDetails, setviewTenderDetails] = useState();
  const [viewTransferDetails, setviewTransferDetails] = useState();

  const [showList, setshowList] = useState();
  const { authenticated } = Auth();
  const acceptHandler = async (id) => {
    const getData = viewTransferDetails;
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const data = JSON.stringify({
      lotTransferId: Number(id),
      lotId: Number(getData.lotId),
      transferFromUserId: Number(getData.transferFromUserId),
      transferToUserId: Number(getData.transferToUserId),
      status: 1,
      approvedByUserId: Number(authenticated.userId),
      comments: getData.comments,
    });
    console.log("LotTransfer/houpdate data : ", data);
    const response = await apiCall(`LotTransfer/houpdate`, "PUT", header, data);
    const jsonobj = await response.json();
    if (response.status === 200 && jsonobj !== -1) {
      history.push("/requestlist/transfertoholotapprovals");
    }
  };

  const rejectHandler = async (id) => {
    const getData = viewTransferDetails;
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `LotTransfer/houpdate`,
      "PUT",
      header,
      JSON.stringify({
        lotTransferId: Number(id),
        lotId: Number(getData.lotId),
        transferFromUserId: Number(getData.transferFromUserId),
        transferToUserId: Number(getData.transferToUserId),
        status: 2,
        approvedByUserId: null,
        comments: getData.comments,
      })
    );
    await response.json();
    if (response.status === 200) {
      history.push("/requestlist/transfertoholotapprovals");
    }
  };

  const getLotDetails = async () => {
    if (authenticated) {
      const header = new Headers();
      // header.append("", "");
      const responseTransferData = await apiCall(
        `LotTransfer?$filter=lotTransferId eq ${lotTransferId}`,
        "GET",
        header,
        null
      );
      const jsonobjTransferData = await responseTransferData.json();
      if (
        responseTransferData.status === 200 &&
        jsonobjTransferData.length > 0
      ) {
        setviewTransferDetails(jsonobjTransferData[0]);

        const response = await apiCall(
          `LotDetails/getLotDetails?$filter=lotId eq ${jsonobjTransferData[0].lotId}`,
          "GET",
          header,
          null
        );
        const jsonobj = await response.json();
        if (response.status === 200) {
          setviewListDetails(jsonobj[0]);
          const responseData = await apiCall(
            `Tender?$filter=tenderId eq ${jsonobj[0].tenderId}`,
            "GET",
            header,
            null
          );
          const jsonobjData = await responseData.json();
          if (responseData.status === 200) {
            setviewTenderDetails(jsonobjData[0]);
            setshowList(true);
          }
        }
      }
    } else {
      setshowList(false);
    }
  };

  useEffect(() => {
    getLotDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotTransferId, authenticated]);

  return (
    <>
      {!showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        authenticated && (
          <CCardHeader>
            <CRow className="pt-3" xl={12}>
              <CCol xl={10}>
                <h3 className="titlehr">Lot Details</h3>
              </CCol>
            </CRow>
            <div className="pl-1 pr-1">
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Lot number :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.lotNo === null
                        ? " "
                        : viewListDetails.lotNo
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Quantity :</CLabel>
                  <CInput
                    value={
                      viewListDetails.quantity === null
                        ? " "
                        : viewListDetails.quantity
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Purchase Rate :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.purchaseRate === null
                        ? " "
                        : viewListDetails.purchaseRate
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Purchase Price :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.purchasePrice === null
                        ? " "
                        : viewListDetails.purchasePrice
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Status :</CLabel>
                  <CInput
                    value={
                      viewListDetails.status === null
                        ? " "
                        : viewListDetails.status
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Emd Amount :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.emdAmount === null
                        ? " "
                        : viewListDetails.emdAmount
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Society : </CLabel>
                  <CInput
                    value={
                      viewListDetails.socity === null
                        ? " "
                        : viewListDetails.socity
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    District Union :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.districtName === null
                        ? " "
                        : viewListDetails.districtName
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Circle Name :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.circleName === null
                        ? " "
                        : viewListDetails.circleName
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
            </div>
            <CRow className="pt-3" xl={12}>
              <CCol xl={10}>
                <h3 className="titlehr">Tender Details</h3>
              </CCol>
            </CRow>
            <div className="pl-1 pr-1">
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Tender number. :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.tenderNo === null
                        ? " "
                        : viewTenderDetails.tenderNo
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Details :</CLabel>
                  <CInput
                    value={
                      viewTenderDetails.details === null
                        ? " "
                        : viewTenderDetails.details
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Publish Date :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.purchaseDate === null
                        ? " "
                        : formatDate(viewTenderDetails.purchaseDate)
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Rebate :</CLabel>
                  <CInput
                    value={
                      viewTenderDetails.rebate === null
                        ? " "
                        : viewTenderDetails.rebate
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Late Fee Per Day :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.lateFeePerDay === null
                        ? " "
                        : viewTenderDetails.lateFeePerDay
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Security Deposit Amount :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.securityDepositAmount === null
                        ? " "
                        : viewTenderDetails.securityDepositAmount
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>

              <CRow className="mt-3">
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Security Deposit Day :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.securityDepositDay === null
                        ? " "
                        : viewTenderDetails.securityDepositDay
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Total Lots :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.totalLots === null
                        ? " "
                        : viewTenderDetails.totalLots
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Collection Season :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.collectionSeason === null
                        ? " "
                        : viewTenderDetails.collectionSeason
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow className="mt-3">
                {[...Array(viewTenderDetails.paymentSlots)].map((e, i) => (
                  <>
                    <CCol xl={4}>
                      <CLabel
                        key={`Payment Due Date label ${i + 1}`}
                        htmlFor="exampleFormControlInput1"
                      >
                        {`Payment Due Date ${i + 1}`} :
                      </CLabel>
                      <CInput
                        key={`Payment Due Date input ${i + 1}`}
                        value={
                          viewTenderDetails.paymentDueDates[i]
                            .paymentDueDate === null
                            ? " "
                            : formatDate(
                                viewTenderDetails.paymentDueDates[i]
                                  .paymentDueDate
                              )
                        }
                        disabled
                        id="exampleFormControlInput1"
                      />
                    </CCol>
                    <CCol xl={4}>
                      <CLabel
                        key={`Payment Complete label ${i + 1}`}
                        htmlFor="exampleFormControlInput1"
                      >
                        {`Payment ${i + 1} Complete`} :
                      </CLabel>
                      <CInput
                        key={`Payment Complete input ${i + 1}`}
                        value={
                          viewTenderDetails.paymentDueDates[i]
                            .paymentComplete === null
                            ? " "
                            : viewTenderDetails.paymentDueDates[i]
                                .paymentComplete
                        }
                        disabled
                        id="exampleFormControlInput1"
                      />
                    </CCol>
                    <CCol xl={2} className={"mt-1"}>
                      <CInput
                        key={`Payment percentage input ${i + 1}`}
                        className="mt-4"
                        value={
                          viewTenderDetails.paymentDueDates[i]
                            .paymentComplete === null
                            ? " "
                            : (
                                (viewTenderDetails.paymentDueDates[i]
                                  .paymentComplete /
                                  100) *
                                viewListDetails.purchasePrice
                              ).toFixed(2)
                        }
                        disabled
                        id="exampleFormControlInput1"
                      />
                    </CCol>
                    <CCol xl={2}></CCol>
                  </>
                ))}
              </CRow>
            </div>
            {viewTransferDetails && (
              <>
                <CRow className="pt-3" xl={12}>
                  <CCol xl={10}>
                    <h3 className="titlehr">Transfer Details</h3>
                  </CCol>
                </CRow>
                <div className="pl-1 pr-1">
                  <CRow className="mt-3">
                    {authenticated.userId !== viewListDetails.userId && (
                      <CCol xl={3}>
                        <CLabel htmlFor="exampleFormControlInput1">
                          Transferor :
                        </CLabel>
                        <CInput
                          value={
                            viewTransferDetails.transferFromUser === null
                              ? " "
                              : viewTransferDetails.transferFromUser
                          }
                          disabled
                          id="exampleFormControlInput1"
                        />
                      </CCol>
                    )}
                    <CCol xl={3}>
                      <CLabel htmlFor="exampleFormControlInput1">
                        Transferee :
                      </CLabel>
                      <CInput
                        value={
                          viewTransferDetails.transferToUser === null
                            ? " "
                            : viewTransferDetails.transferToUser
                        }
                        disabled
                        id="exampleFormControlInput1"
                      />
                    </CCol>
                    <CCol xl={2}>
                      <CLabel htmlFor="exampleFormControlInput1">
                        Request Date :
                      </CLabel>
                      <CInput
                        value={
                          viewTransferDetails.requestDateTime === null
                            ? " "
                            : formatDate(viewTransferDetails.requestDateTime)
                        }
                        disabled
                        id="exampleFormControlInput1"
                      />
                    </CCol>
                    <CCol xl={2}>
                      <CLabel htmlFor="exampleFormControlInput1">
                        Request Update Date :
                      </CLabel>
                      <CInput
                        value={
                          viewTransferDetails.requestUpdateDateTime === null
                            ? " "
                            : formatDate(
                                viewTransferDetails.requestUpdateDateTime
                              )
                        }
                        disabled
                        id="exampleFormControlInput1"
                      />
                    </CCol>

                    <CCol xl={2}>
                      <CLabel htmlFor="exampleFormControlInput1">
                        Status :
                      </CLabel>
                      <h5>
                        {viewTransferDetails.status === null ? (
                          " "
                        ) : viewTransferDetails.status === 0 ? (
                          <span class="badge bg-warning text-dark">
                            Pending
                          </span>
                        ) : viewTransferDetails.status === 1 ? (
                          <span class="badge bg-success text-light">
                            Accepted
                          </span>
                        ) : (
                          <span class="badge bg-danger text-light">
                            Rejected
                          </span>
                        )}
                      </h5>
                    </CCol>
                  </CRow>

                  <CRow className="mt-4">
                    <CCol xl={12}>
                      <CLabel htmlFor="exampleFormControlInput1">
                        Transfered Lot Comment :
                      </CLabel>
                      {viewTransferDetails.comments === null
                        ? ""
                        : viewTransferDetails.comments}
                    </CCol>
                    <CCol xl={12} className={"mt-1"}>
                      <a
                        href={`${downloadUrl}/${viewTransferDetails.uploadDocumentPath}`}
                        target="_blank"
                        className="ml-2"
                        rel="noreferrer"
                      >
                        <CButton
                          variant="outline"
                          shape="square"
                          size="sm"
                          color="success"
                        >
                          View Transfered Document
                        </CButton>
                      </a>
                    </CCol>
                  </CRow>
                </div>
              </>
            )}
            <div className="pl-1 pr-1">
              {viewTransferDetails ? (
                <>
                  <CButton
                    key="accept"
                    color="info"
                    className="mt-4 mb-2 ml-2"
                    // to={props.seccpath + item[props.id]}
                    onClick={() => {
                      acceptHandler(viewTransferDetails.lotTransferId);
                    }}
                  >
                    Accept
                  </CButton>
                  <CButton
                    key="reject"
                    color="danger"
                    className="mt-4 mb-2 ml-2 mr-2"
                    // to={props.seccpath + item[props.id]}
                    onClick={() =>
                      rejectHandler(viewTransferDetails.lotTransferId)
                    }
                  >
                    Reject
                  </CButton>
                </>
              ) : (
                ""
              )}

              <CButton
                className="mt-4 mb-2"
                color="success"
                onClick={() => history.goBack()}
              >
                Go Back
              </CButton>
            </div>
          </CCardHeader>
        )
      )}
    </>
  );
};
export default TransferLotRequestHOListView;
